export const alpha = {
    primary04: "rgba(5, 122, 53, 0.04)",
    primary08: "rgba(5, 122, 53, 0.08)",
    primary15: "rgba(5, 122, 53, 0.15)",
    primary30: "rgba(0, 134, 53, 0.3)",
    primary45: "rgba(5, 122, 53, 0.45)",
    primary75: "rgba(5, 122, 53, 0.75)",
    error04: "rgba(211, 47, 47, 0.04)",
    error06: "rgba(211, 47, 47, 0.06)",
    error08: "rgba(211, 47, 47, 0.08)",
};

// Single source of truth for every themed color in the app. ThemeContext
// derives both the MUI palette and the legacy CSS custom properties from
// these two objects, so a color only ever needs to change here.
export const lightTokens = {
    primary: "#057a35",
    primaryDark: "#045a28",
    error: "#d32f2f",
    errorBright: "#f44336",
    errorDarker: "#b71c1c",
    danger: "#d32f2f",
    dangerSoft: "#fdecea",
    warning: "#ed6c02",
    warningSoft: "#fff3e0",
    stickyHeaderBg: "#b3dbc2",
    tableHeaderBg: "#9e9e9e",
    tableHeaderText: "#ffffff",

    bgBody: "#f4f5f7",
    bgPaper: "#ffffff",
    bgSidebar: "#ffffff",
    bgNavbar: "#ffffff",
    bgCard: "#ffffff",
    bgInput: "#ffffff",
    textPrimary: "#212121",
    textSecondary: "#666666",
    textMuted: "#888888",
    borderColor: "#cccccc",
    borderLight: "#e0e0e0",
    tabActiveBorder: "#057a35",
    tabActiveBg: "#e8f5e9",
    tabActiveText: "#00796b",
    dropdownBg: "#ffffff",
    dropdownHover: "#f3f4f6",
};

export const darkTokens = {
    primary: "#4caf50",
    primaryDark: "#388e3c",
    error: "#d32f2f",
    errorBright: "#f44336",
    errorDarker: "#b71c1c",
    danger: "#f44336",
    dangerSoft: "#3a1a17",
    warning: "#ffa726",
    warningSoft: "#3d2a12",
    stickyHeaderBg: "#1f3d2a",
    tableHeaderBg: "#424242",
    tableHeaderText: "#f5f5f5",

    bgBody: "#121212",
    bgPaper: "#1e1e1e",
    bgSidebar: "#1e1e1e",
    bgNavbar: "#1e1e1e",
    bgCard: "#2d2d2d",
    bgInput: "#2d2d2d",
    textPrimary: "#e0e0e0",
    textSecondary: "#a0a0a0",
    textMuted: "#888888",
    borderColor: "#444444",
    borderLight: "#333333",
    tabActiveBorder: "#4caf50",
    tabActiveBg: "#1b3a1b",
    tabActiveText: "#4caf50",
    dropdownBg: "#2d2d2d",
    dropdownHover: "#3d3d3d",
};

// Maps each token key to the legacy CSS custom property name it drives,
// so ThemeContext can sync `index.css`/hand-written .css consumers at runtime.
export const CSS_VAR_MAP = {
    primary: "--color-primary",
    primaryDark: "--color-primary-dark",
    error: "--color-error",
    errorBright: "--color-error-bright",
    errorDarker: "--color-error-darker",
    danger: "--color-danger",
    dangerSoft: "--color-danger-soft",
    warning: "--color-warning",
    warningSoft: "--color-warning-soft",
    stickyHeaderBg: "--sticky-header-bg",
    tableHeaderBg: "--table-header-bg",
    tableHeaderText: "--table-header-text",
    bgBody: "--bg-body",
    bgPaper: "--bg-paper",
    bgSidebar: "--bg-sidebar",
    bgNavbar: "--bg-navbar",
    bgCard: "--bg-card",
    bgInput: "--bg-input",
    textPrimary: "--text-primary",
    textSecondary: "--text-secondary",
    textMuted: "--text-muted",
    borderColor: "--border-color",
    borderLight: "--border-light",
    tabActiveBorder: "--tab-active-border",
    tabActiveBg: "--tab-active-bg",
    tabActiveText: "--tab-active-text",
    dropdownBg: "--dropdown-bg",
    dropdownHover: "--dropdown-hover",
};
